<div class="sub-menu-navigation w-100" *ngIf="tabs && tabs.length">
    <hr class="sub-menu-navigation-divider w-100 m-0" />
    <nav class="sub-menu-navigation-nav w-100">
        <ul class="nav sub-menu-navigation-list">
            <li class="nav-item" *ngFor="let tab of tabs; let i = index">
                <a class="nav-link text-capitalize sub-menu-navigation-link"
                   [class.active]="i === activeIndex"
                   (click)="select(i)"
                   [href]="tab.url"
                   [target]="tab.target || '_self'">
                    {{ tab.label }}
                </a>
            </li>
        </ul>
    </nav>
    <hr class="sub-menu-navigation-divider w-100 m-0" />
</div>
